import React, { ReactNode, useEffect, useState } from 'react';
import CustomTable from '../../components/Table/CustomTable';
import { FaPlusCircle, FaSearch } from 'react-icons/fa';
import { Button, Datepicker, Dropdown, Pagination, Spinner, TextInput } from 'flowbite-react';
import PrivateLayout from '../../layouts/PrivateLayout/PrivateLayout';
import filterIcon from '../../assets/filterIcon.png';
import downloadIcon from '../../assets/document-download.png';
import CustomModal from '../Modal/CustomModal';
import client from '../../api/client';
import showToast from '../CustomToast/toastHelper';
import * as XLSX from 'xlsx';
import FilterButton from '../FilterButton/FilterButton';
import { exportToCSV } from '../../utils/exportToCSV';
import { exportToXLSX } from '../../utils/exportToXLSX';
import logo from '../../assets/Ideos.png'

interface Filters {
    [key: string]: any;
}

interface DashboardPagesProps {
    apiUrl: string,
    title: string,
    tableContainerClass?: string,
    dataToExport?: any,
    dropdownItems: Array<any>,
    dropdownItemsValue?: string,
    buttonLabel: string,
    buttonIcon: any,
    showSearch: boolean,
    ctaButtonExists: boolean,
    exportButtonExists: boolean,
    children?: ReactNode,
    modalTitle?: string,
    modalIcon?: any,
    modalSubtitle?: any,
    filters: Filters,
    onFilterChange: React.Dispatch<React.SetStateAction<any>>,
    headingToPropertyMap?: any[],
    headings?: any[],
    actions?: Array<any>,
    data?: any[];
    datepickerExists?: boolean;
    emptyMessage?: string,
    openModal?: () => void,
    closeModal?: () => void
    show?: boolean
    statusKey?: string,
    onCtaButtonClick?: () => void,
    loading?: boolean,
    exportButtonClicked?: boolean,
    exportButtonLoading?: boolean,
    clickExportButton?: () => void,
    modalSize?: string

}

const DashboardPagesTemplate = ({
    apiUrl,
    title,
    ctaButtonExists,
    exportButtonExists,
    dropdownItems,
    dropdownItemsValue,
    buttonLabel,
    buttonIcon,
    showSearch,
    children,
    modalTitle,
    modalIcon,
    modalSubtitle,
    filters,
    onFilterChange,
    headings,
    headingToPropertyMap,
    actions,
    data,
    datepickerExists = true,
    emptyMessage,
    dataToExport,
    openModal,
    closeModal,
    show, statusKey,
    onCtaButtonClick,
    loading,
    exportButtonClicked,
    exportButtonLoading,
    clickExportButton,
    tableContainerClass = "overflow-x-auto",
    modalSize

}: DashboardPagesProps) => {
    const [selectedOption, setSelectedOption] = useState(dropdownItems[0]);
    const [showModal, setShowModal] = useState(false);
    const [filter, setFilter] = useState(filters);
    const [apiResponse, setApiResponse] = useState<any[]>([]);
    const [searchQuery, setSearchQuery] = useState('');

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(event.target.value);
    };



    useEffect(() => {
        onFilterChange(filter);
    }, [filter, onFilterChange]);

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleDropdownChange = (item: string) => {
        setSelectedOption(item);
        if (statusKey) {
            const updatedFilters = { ...filter };
            if (item === "All") {
                delete updatedFilters[statusKey];
            } else {
                updatedFilters[statusKey] = item;
            }
            setFilter(updatedFilters);
        }
    };

    const filteredData = data?.filter(item => {
        return Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        );
    });

    const currentDate = new Date().toLocaleDateString('en-CA')



    return (
        <PrivateLayout>
            <div className='py-4 px-8 w-full'>
                <div className='flex items-center gap-4 mb-1 w-full'>
                    <p className='text-xl '>{title}</p>
                </div>
                <hr />
                <div className='flex flex-col lg:flex-row justify-between lg:items-center gap-4 my-4 w-full'>
                    {datepickerExists && (
                        <div className='flex items-center gap-4'>
                            {'fromDate' in filters && (
                                <Datepicker name='fromDate' onSelectedDateChanged={(date) => setFilter({ ...filter, fromDate: date.toISOString() })} />
                            )}
                            <span>to</span>
                            {'toDate' in filters && (
                                <Datepicker onSelectedDateChanged={(date) => setFilter({ ...filter, toDate: date.toISOString() })} />
                            )}
                            {dropdownItems.length > 0 && (
                                <div className='bg-custom-button-green p-2 rounded-md'>
                                    <Dropdown
                                        label={
                                            <div className='flex items-center gap-2 text-sm h-full'>
                                                <div>
                                                    <img src={filterIcon} alt='Filter' />
                                                </div>
                                                <p>{selectedOption}</p>
                                            </div>
                                        }
                                        inline
                                        dismissOnClick={true}
                                    >
                                        {dropdownItems.map((item) => (
                                            <Dropdown.Item
                                                key={item}
                                                onClick={() => handleDropdownChange(item)}
                                            >
                                                {item}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown>
                                </div>
                                // <FilterButton key={key} currentFilters={fil}/>
                            )}
                        </div>)}
                    <div className='flex gap-4 mt-4 lg:mt-0 '>
                        {showSearch && <TextInput className='w-2/3 lg:w-64' icon={FaSearch} placeholder='Search transaction by reference' value={searchQuery} onChange={handleSearchChange} />}
                        {exportButtonExists && (
                            (
                                <Dropdown
                                    label={
                                        <Button className='rounded-md bg-black' onClick={() => clickExportButton && clickExportButton()}>
                                            {exportButtonLoading ? <Spinner /> : <div className='flex gap-2'>
                                                <img src={downloadIcon} alt="Download" />
                                                <p>Export</p>
                                            </div>}
                                        </Button>
                                    }
                                    inline
                                    arrowIcon={false}
                                >
                                    {exportButtonClicked && dataToExport?.length > 0 ? (
                                        <>
                                            <Dropdown.Item onClick={() => exportToCSV(dataToExport, `${title}-${currentDate}.csv`)}>Export as .csv</Dropdown.Item>
                                            <Dropdown.Item onClick={() => exportToXLSX(dataToExport, `${title}-${currentDate}.xlsx`)}>Export as .xls</Dropdown.Item>
                                        </>

                                    ) : <Dropdown.Item>No data available</Dropdown.Item>}

                                </Dropdown>
                            )
                        )}

                        {ctaButtonExists && (
                            <Button className='rounded-sm bg-green-800 hover:bg-black' onClick={onCtaButtonClick ? onCtaButtonClick : openModal ? openModal : handleOpenModal}>
                                <div className='flex items-center gap-2'>
                                    {buttonIcon}
                                    <span>{buttonLabel}</span>
                                </div>
                            </Button>
                        )}
                    </div>
                </div>
                <div className='my-4 w-full'>
                    <CustomTable parentClass={tableContainerClass ? tableContainerClass : ''} headings={headings} data={filteredData} actions={actions} emptyMessage={emptyMessage} loading={loading} />
                </div>
            </div>
            <CustomModal size={modalSize ? modalSize : 'md'} title={modalTitle} subtitle={modalSubtitle} icon={modalIcon} dismissible={true} show={show ? show : showModal} onClose={closeModal ? closeModal : handleCloseModal}>
                {children}
            </CustomModal>
            {loading && (
                <div className="absolute inset-0 z-50 flex items-center justify-center ">
                    <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                </div>
            )}
        </PrivateLayout>
    );
};

export default DashboardPagesTemplate;
